/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2023-03-23 14:56:25
 */
import classnames from 'classnames';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './index.module.scss';
interface Props {
  className?: string;
  count?: number;
  size?: 'small' | 'large';
}

interface Star {
  index: number;
  type: 'full' | 'hollow';
}
const ImageStars: React.FC<Props> = ({ count, className, size }) => {
  const stars = useMemo<Star[]>(() => {
    const arr: Star[] = [];
    if (!count) return arr;
    for (let i = 0; i < count; i += 1) {
      if (i < 10) {
        arr.push({ index: i, type: 'hollow' });
      } else {
        arr[i - 10].type = 'full';
      }
    }
    return arr;
  }, [count]);
  return (
    <div
      className={classNames(
        styles.container,
        className,
        styles[size || 'small']
      )}
    >
      {stars.map(v => (
        <div
          className={classnames(styles.star, styles[v.type])}
          key={v.index}
        />
      ))}
    </div>
  );
};

export default React.memo(ImageStars);
